<template>
  <div :class="'d-flex align-items-center alert alert-light-' + type">
    <FontAwesomeIcon v-if="icon" :icon="'fa-light fa-' + icon" />
    <p :class="'mb-0 ' + (icon ? 'ms-2' : '')" v-html="text"></p>
  </div>
</template>

<script>
export default {
  name: "AlertBlock",
  props: {
    type: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
